export const DUPLICATED_OPERATOR_NAME_RESPONSE_MESSAGE: string = "IX_Operators_Name";
export const DUPLICATED_OPERATOR_LOGIN_RESPONSE_MESSAGE: string = "IX_Operators_Login";